(function () {
  'use strict';

  function DeviceHealthConfiguration() {
    return {
      templateUrl: `configuracoes/eventos/subpaginas/device-health-configuration/device-health-configuration.tpl.html`,
      controller: 'DeviceHealthConfigurationCtrl',
      controllerAs: 'ctrl',
      restrict: 'E',
      scope: {}
    };
  }

  angular
    .module('SubpaginasEventos')
    .directive('deviceHealthConfigurationEventos', DeviceHealthConfiguration);
}());
